module.exports = __webpack_public_path__ + "static/media/Abbey-Knoll-Estates-Declaration-of-Restrictions.8ed1d1f0.pdf";